import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import HideAppBar from "../../widgets/header/HideAppBar";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {
	Card,
	CardContent,
	CardHeader,
	Container,
	DialogActions,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import moment from "moment";
import {getAccountInfo} from "../../../utils/GenericUtils";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import Button from "@mui/material/Button";
import {onClickDetails} from "../../../services/AutomationServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AppContext} from "../../../App";
import {useHistory} from "react-router-dom";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import CalendarHeader from "./viste/mese/CalendarHeader";
import ScadenziarioCalendarDays from "./viste/mese/ScadenziarioCalendarDays";
import ScadenziarioCell from "./viste/mese/ScadenziarioCell";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";
import {getAllTamponiByMonth, getTamponiByEndDay, resetTamponiDay} from "../../../services/TamponiServices";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../reducers/TamponiReducer";
import TamponeCard from "../tamponi/details/TamponeCard";

const GestioneCalendarioTamponi = () => {
	const classes = BaseStyle();
	const [currentMonth, setCurrentMonth] = useState(new Date());
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const appContext = useContext(AppContext);
	let history = useHistory();
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState("");
	const [pageNumber, setPageNumber] = useState(0);
	const observer = useRef();
	const [stato, setStato] = useSessionStorage("statoCalTamp", "Da gestire");
	const [giorno, setGiorno] = useSessionStorage("giornoCalTamp", "dataEsito");
	
	const lastTicketElementRef = useCallback(node => {
		if (state.loadingGetTamponiByDay) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && state.tamponiDayPayload.length > 0) {
				let day = selectedDate
				day.setHours(0);
				day.setMinutes(0);
				day.setSeconds(0);
				day.setMilliseconds(0);
				getTamponiByEndDay({
					[giorno]: day,
					stato: stato,
					active: null,
				}, dispatch, pageNumber + 1);
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [state.loadingGetTamponiByDay, state.tamponiDayPayload, selectedDate, pageNumber, stato, giorno])
	
	const onDateClick = day => {
		setPageNumber(0);
		resetTamponiDay(dispatch);
		setOpen(true);
		let selectedDay = day
		selectedDay.setHours(0);
		selectedDay.setMinutes(0);
		selectedDay.setSeconds(0);
		selectedDay.setMilliseconds(0);
		setSelectedDate(selectedDay);
		getTamponiByEndDay({
			[giorno]: selectedDay,
			stato: stato,
			active: null,
		}, dispatch, pageNumber);
	};
	
	const onClickTampone = (tampone) => {
		setSelected(tampone);
		onClickDetails(tampone.id, "tampone", "modify", automationDispatch);
	}
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/interviste/" + selected.id);
			} else {
				setOpenSnackbar("warning", ("Il tampone è al momento gestito da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	useEffect(() => {
		getAllTamponiByMonth(currentMonth, dispatch)
	}, [currentMonth, dispatch])
	
	useEffect(() => {
		setPageNumber(0);
	}, [selectedDate, giorno, stato])
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Calendario tamponi"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent className={classes.calendar}>
									
									{
										state.loadingGetTamponiByMonth ?
											
											<React.Fragment>
												<CalendarHeader currentMonth={currentMonth} setCurrentMonth={setCurrentMonth}/>
												<ScadenziarioCalendarDays currentMonth={currentMonth}/>
												<ScadenziarioCell currentMonth={currentMonth} selectedDate={selectedDate}
												                  tamponiState={state} isLoading={true}
												                  onDateClick={onDateClick}/>
											</React.Fragment> :
											state.errorGetTamponiByMonth !== "" ? <Alert severity="error" style={{borderRadius: 24}}>
													<AlertTitle>Errore</AlertTitle>
													Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta
													gli sviluppatori.
												</Alert> :
												<React.Fragment>
													<CalendarHeader currentMonth={currentMonth} setCurrentMonth={setCurrentMonth}/>
													<ScadenziarioCalendarDays currentMonth={currentMonth}/>
													<ScadenziarioCell currentMonth={currentMonth} selectedDate={selectedDate}
													                  tamponiState={state}
													                  onDateClick={onDateClick}/>
												</React.Fragment>
									}
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
            <SimpleDialog
				open={open}
				handleClose={() => setOpen(false)}
				title={moment(selectedDate).format("D MMMM YYYY")}
				maxWidth={"md"}
				content={
					<React.Fragment>
						<Grid container spacing={2} style={{marginBottom: 20}}>
							<Grid item xs={6}>
								<FormControl variant={"outlined"} fullWidth={true}>
									<InputLabel htmlFor="grouped-native-select">Stato</InputLabel>
									<Select
										label={"Stato"}
										labelId="stato-label"
										id="grouped-native-select"
										value={stato}
										onChange={(e) => {
											setStato(e.target.value);
											resetTamponiDay(dispatch);
										}}
									>
										<MenuItem value={"Da gestire"}>Da gestire</MenuItem>
										<MenuItem value={"Preso in carico"}>Presi in carico</MenuItem>
										<MenuItem value={"Gestito"}>Gestiti</MenuItem>
										<MenuItem value={"Irreperbile"}>Irreperibile</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={3}>
								<FormControl variant={"outlined"} fullWidth={true}>
									<InputLabel htmlFor="grouped-native-select-1">Giorno</InputLabel>
									<Select
										label={"Giorno"}
										labelId="giorno-label"
										id="grouped-native-select-1"
										value={giorno}
										onChange={(e) => {
											setGiorno(e.target.value);
											resetTamponiDay(dispatch);
										}}
									>
										<MenuItem value={"dataEsito"}>Data esito</MenuItem>
										<MenuItem value={"dataPrelievoPrevista"}>Data prelievo prevista</MenuItem>
										<MenuItem value={"dataPrelievoEffettiva"}>Data prelievo effettiva</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={3}>
								<Button variant={"outlined"} onClick={
									() => getTamponiByEndDay({
										[giorno]: selectedDate,
										stato: stato,
										active: null,
									}, dispatch, pageNumber)}
								        style={{
									        height: "100%",
									        width: "100%",
								        }}
								>
									<b>Cerca</b>
								</Button>
							</Grid>
						</Grid>
						
						
						{
							state.tamponiDay.length === 0 && !state.loadingGetTamponiByDay && <Typography>
								Non ci sono tamponi con stato <b>{stato}</b> al giorno selezionato
							</Typography>
						}
						{
							state.tamponiDay.map((tampone, index) => {
								if (state.tamponiDay.length === index + 1) {
									return (
										<Card ref={lastTicketElementRef} key={tampone.id}
										      className={clsx(classes.roundBorder, classes.mailCard)}>
											<TamponeCard tampone={tampone} onClickTampone={onClickTampone} setValue={() => {
											}}/>
										</Card>
									)
								} else {
									return (
										<Card key={tampone.id} className={clsx(classes.roundBorder, classes.mailCard)}>
											<TamponeCard tampone={tampone} onClickTampone={onClickTampone} setValue={() => {
											}}/>
										</Card>
									)
								}
							})
						}
						{state.loadingGetTamponiByDay &&
							<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
								<CardHeader
									avatar={<Skeleton variant="circular" height={40} width={40}/>}
									title={<Skeleton width={180}/>}
									subheader={<Skeleton width={260}/>}
									action={<Skeleton variant="circular" height={20} width={20}/>}
									style={{paddingBottom: 2}}
								/>
								<CardContent style={{paddingTop: 0, marginTop: -35}}>
									<Skeleton height={200}/>
								</CardContent>
							</Card>}
					</React.Fragment>
				}
				actions={
					<DialogActions>
						<Button onClick={() => setOpen(false)} size={"small"} variant={"contained"}
						        className={classes.roundButton} style={{borderRadius: 24}} color={"primary"} disableElevation>
							<b>Chiudi</b>
						</Button>
					</DialogActions>
				}
			/>
        </React.Fragment>
    );
};

export default React.memo(GestioneCalendarioTamponi)
